import React from "react";
import "./Services.css";
import DesignIllustration from "./illustrations/DesignIllustration";
import RealEstateIllustration from "./illustrations/RealEstateIllustration";
import {
  FaCheckCircle,
  FaCalculator,
  FaCity,
  FaArrowRight,
} from "react-icons/fa";
import useInView from "../hooks/useInView";
import { Link as ScrollLink } from "react-scroll";

const SERVICES = [
  {
    Illustration: DesignIllustration,
    Icon: FaCalculator,
    title: "Designing & Estimation",
    tagline: "Built for builders",
    blurb:
      "Highly accurate cost estimates that take the guesswork out of project planning. From quantity takeoffs to detailed CAD support — we help builders and developers stay on budget and on schedule.",
    features: [
      "Quantity Takeoff (QTO)",
      "Bid & Tender Estimation",
      "Cost Control & Reporting",
      "CAD Drafting & Design Support",
    ],
    accent: "#8a5cf6",
  },
  {
    Illustration: RealEstateIllustration,
    Icon: FaCity,
    title: "Real Estate Services",
    tagline: "Properties that move",
    blurb:
      "A leading brokerage across commercial, retail, and industrial property markets. Investment sales, leasing, and development advisory — handled by an experienced team that knows the market inside out.",
    features: [
      "Investment Sales & Acquisitions",
      "Leasing & Property Management",
      "Commercial & Industrial Brokerage",
      "Development Advisory",
    ],
    accent: "#22d3ee",
  },
];

const ServiceCard = ({
  Illustration,
  Icon,
  title,
  tagline,
  blurb,
  features,
  accent,
  delay,
}) => {
  const [ref, inView] = useInView();
  return (
    <div
      ref={ref}
      className={`service-box ${inView ? "in-view" : ""}`}
      style={{ transitionDelay: `${delay}ms`, "--accent": accent }}
    >
      <div className="service-image-wrap">
        <Illustration />
        <div className="service-image-overlay" />
        <span className="service-tagline">{tagline}</span>
        <div className="service-icon-badge">
          <Icon />
        </div>
      </div>
      <div className="service-body">
        <h3>{title}</h3>
        <p>{blurb}</p>
        <ul className="service-features">
          {features.map((f) => (
            <li key={f}>
              <FaCheckCircle className="tick" />
              <span>{f}</span>
            </li>
          ))}
        </ul>
        <ScrollLink
          to="contact"
          smooth={true}
          duration={500}
          offset={-70}
          className="service-cta"
        >
          Get a quote <FaArrowRight />
        </ScrollLink>
      </div>
    </div>
  );
};

const Services = () => {
  const [headRef, headInView] = useInView();

  return (
    <section id="services" className="services-section">
      <span className="services-orb orb-1" />
      <span className="services-orb orb-2" />

      <div className="services-container">
        <div
          ref={headRef}
          className={`services-head ${headInView ? "in-view" : ""}`}
        >
          <span className="section-eyebrow">What We Do</span>
          <h2 className="services-title">
            Two core practices,{" "}
            <span className="gradient-text">one standard</span>
          </h2>
          <p className="services-sub">
            Quality work, delivered on time. Whether you're planning a build
            or moving a property — your project gets the same level of care.
          </p>
        </div>

        <div className="services-grid services-grid-2">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.title} {...s} delay={i * 120} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
